"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M35.543 9.857A7.739 7.739 0 0 0 34.119 6.3a5.119 5.119 0 0 0-3.586-1.516c-5.01-.362-12.525-.362-12.525-.362h-.016s-7.515 0-12.525.362A5.121 5.121 0 0 0 1.881 6.3 7.733 7.733 0 0 0 .458 9.857 54.09 54.09 0 0 0 .1 15.651v2.716a54.1 54.1 0 0 0 .358 5.794 7.734 7.734 0 0 0 1.423 3.553 6.069 6.069 0 0 0 3.947 1.53C8.693 29.519 18 29.6 18 29.6s7.522-.011 12.533-.373a5.12 5.12 0 0 0 3.586-1.516 7.74 7.74 0 0 0 1.424-3.553 54.241 54.241 0 0 0 .357-5.794v-2.713a54.235 54.235 0 0 0-.357-5.794zM14 22.175V11.569l10.583 5.321z" })
);

